/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Permissions_DescriptionInputs */

const en_explorer_info_permissions_description = /** @type {(inputs: Explorer_Info_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select groups that can access this folder:`)
};

const fr_explorer_info_permissions_description = /** @type {(inputs: Explorer_Info_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionnez les groupes pouvant acceder a ce dossier :`)
};

const de_explorer_info_permissions_description = /** @type {(inputs: Explorer_Info_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die Gruppen aus, die auf diesen Ordner zugreifen können:`)
};

const it_explorer_info_permissions_description = /** @type {(inputs: Explorer_Info_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona i gruppi che possono accedere a questa cartella:`)
};

const ru_explorer_info_permissions_description = /** @type {(inputs: Explorer_Info_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите группы, которым разрешен доступ к этой папке:`)
};

const es_explorer_info_permissions_description = /** @type {(inputs: Explorer_Info_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar grupos que pueden acceder a esta carpeta:`)
};

const zh_cn2_explorer_info_permissions_description = /** @type {(inputs: Explorer_Info_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择可以访问此文件夹的组：`)
};

const ja_explorer_info_permissions_description = /** @type {(inputs: Explorer_Info_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このフォルダにアクセスできるグループを選択してください:`)
};

const hi_explorer_info_permissions_description = /** @type {(inputs: Explorer_Info_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उन समूहों का चयन करें जो इस फ़ोल्डर तक पहुंच सकते हैं:`)
};

const pt_pt2_explorer_info_permissions_description = /** @type {(inputs: Explorer_Info_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione os grupos que podem acessar esta pasta:`)
};

/**
* | output |
* | --- |
* | "Select groups that can access this folder:" |
*
* @param {Explorer_Info_Permissions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_permissions_description = /** @type {((inputs?: Explorer_Info_Permissions_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Permissions_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_permissions_description(inputs)
	if (locale === "de") return de_explorer_info_permissions_description(inputs)
	if (locale === "it") return it_explorer_info_permissions_description(inputs)
	if (locale === "ru") return ru_explorer_info_permissions_description(inputs)
	if (locale === "es") return es_explorer_info_permissions_description(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_permissions_description(inputs)
	if (locale === "ja") return ja_explorer_info_permissions_description(inputs)
	if (locale === "hi") return hi_explorer_info_permissions_description(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_permissions_description(inputs)
	return en_explorer_info_permissions_description(inputs)
});